import { h } from '@stencil/core';
export class InputField {
  constructor() {
    this.onIconClick = () => setTimeout(() => this.setFocus());
    this.onFocus = (e) => this.inputFocused.emit(e);
    this.onBlur = (e) => this.inputBlurred.emit(e);
    this.onInput = (e) => {
      const element = e.target;
      if (element.value !== this.value) {
        this.onChange(e);
      }
    };
    this.onChange = (e) => {
      const element = e.target;
      const oldValue = this.value ? this.value : null;
      this.value = element.value;
      this.inputValueChanged.emit({
        'id': this.htmlId,
        'name': this.name,
        'value': element.value,
        'oldValue': oldValue
      });
    };
    this.mode = undefined;
    this.label = undefined;
    this.labelSr = false;
    this.assistive = undefined;
    this.type = 'text';
    this.name = undefined;
    this.htmlId = undefined;
    this.value = undefined;
    this.placeholder = undefined;
    this.readonly = false;
    this.disabled = false;
    this.required = false;
    this.valid = false;
    this.autocomplete = 'on';
    this.min = undefined;
    this.max = undefined;
    this.waAriaLabel = undefined;
    this.waAriaExpanded = undefined;
    this.waAriaOwns = undefined;
    this.waAriaHaspopup = undefined;
    this.waAriaAutocomplete = undefined;
    this.waAriaControls = undefined;
    this.waAriaActivedescendant = undefined;
    this.errorMessageId = undefined;
  }
  get input() {
    return this.element.querySelector('.js-oebb-input');
  }
  componentWillLoad() {
    this.iconStart = !!this.element.querySelector('[slot=icon-start]');
    this.iconEnd = !!this.element.querySelector('[slot=icon-end]');
  }
  async setFocus() {
    const input = this.input;
    input.focus();
    setTimeout(() => {
      input.selectionStart = input.selectionEnd = input.value.length;
    }); // Set cursor to end, needs timeout
  }
  async doBlur() {
    this.input.blur();
  }
  render() {
    return (h("div", { class: "oebb-input-field" }, this.label ?
      h("div", { class: "oebb-input-field-label-wrap" }, h("label", { htmlFor: this.htmlId, class: { 'screen-reader-text': this.labelSr } }, this.label, this.assistive ?
        h("small", null, this.assistive) : null))
      : null, h("div", { class: "oebb-input-field-wrap js-oebb-input-field-wrap", "aria-owns": this.waAriaOwns, "aria-expanded": this.waAriaExpanded, "aria-haspopup": this.waAriaHaspopup }, h("input", { type: this.type, name: this.name, id: this.htmlId, readonly: this.readonly, disabled: this.disabled, autocomplete: this.autocomplete, min: this.min, max: this.max, value: this.value, onFocus: this.onFocus, onBlur: this.onBlur, onInput: this.onInput, onChange: this.onChange, class: {
        'oebb-input js-oebb-input': true,
        'oebb-input--readonly': this.readonly,
        'oebb-input--icon-start': this.iconStart,
        'oebb-input--icon-end': this.iconEnd
      }, "aria-required": this.required + "", "aria-invalid": !this.valid + "", "aria-describedby": this.errorMessageId, placeholder: this.placeholder, "aria-label": this.waAriaLabel, "aria-autocomplete": this.waAriaAutocomplete, "aria-controls": this.waAriaControls }), this.iconStart ? (h("div", { class: "icon-start", onClick: this.onIconClick }, h("slot", { name: "icon-start" }))) : null, this.iconEnd ? (h("div", { class: "icon-end", onClick: this.onIconClick }, h("slot", { name: "icon-end" }))) : null)));
  }
  static get is() { return "oebbx-input-field"; }
  static get originalStyleUrls() {
    return {
      "2022": ["input-field-2022.scss"],
      "default": ["input-field.scss"]
    };
  }
  static get styleUrls() {
    return {
      "2022": ["input-field-2022.css"],
      "default": ["input-field.css"]
    };
  }
  static get properties() {
    return {
      "mode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "mode",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label",
        "reflect": false
      },
      "labelSr": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label-sr",
        "reflect": false,
        "defaultValue": "false"
      },
      "assistive": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "assistive",
        "reflect": false
      },
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "type",
        "reflect": false,
        "defaultValue": "'text'"
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false
      },
      "htmlId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "html-id",
        "reflect": false
      },
      "value": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "value",
        "reflect": false
      },
      "placeholder": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "placeholder",
        "reflect": false
      },
      "readonly": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "readonly",
        "reflect": false,
        "defaultValue": "false"
      },
      "disabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "required": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "required",
        "reflect": false,
        "defaultValue": "false"
      },
      "valid": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "valid",
        "reflect": false,
        "defaultValue": "false"
      },
      "autocomplete": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "autocomplete",
        "reflect": false,
        "defaultValue": "'on'"
      },
      "min": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "min",
        "reflect": false
      },
      "max": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "max",
        "reflect": false
      },
      "waAriaLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "wa-aria-label",
        "reflect": false
      },
      "waAriaExpanded": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "wa-aria-expanded",
        "reflect": false
      },
      "waAriaOwns": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "wa-aria-owns",
        "reflect": false
      },
      "waAriaHaspopup": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "wa-aria-haspopup",
        "reflect": false
      },
      "waAriaAutocomplete": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "wa-aria-autocomplete",
        "reflect": false
      },
      "waAriaControls": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "wa-aria-controls",
        "reflect": false
      },
      "waAriaActivedescendant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "wa-aria-activedescendant",
        "reflect": false
      },
      "errorMessageId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "error-message-id",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "inputFocused",
        "name": "inputFocused",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "UIEvent",
          "resolved": "UIEvent",
          "references": {
            "UIEvent": {
              "location": "global"
            }
          }
        }
      }, {
        "method": "inputBlurred",
        "name": "inputBlurred",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "UIEvent",
          "resolved": "UIEvent",
          "references": {
            "UIEvent": {
              "location": "global"
            }
          }
        }
      }, {
        "method": "inputValueChanged",
        "name": "inputValueChanged",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get methods() {
    return {
      "setFocus": {
        "complexType": {
          "signature": "() => Promise<void>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      },
      "doBlur": {
        "complexType": {
          "signature": "() => Promise<void>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      }
    };
  }
  static get elementRef() { return "element"; }
}
//# sourceMappingURL=input-field.js.map
